import DOC from './DOC';
import FileFormat from './FileFormat';
import JPG from './JPG';
import PDF from './PDF';
import PNG from './PNG';
import PPT from './PPT';
import XLS from './XLS';
export const FileTypeIcons = {
    DOC,
    FileFormat,
    JPG,
    PDF,
    PNG,
    PPT,
    XLS,
};
export default FileTypeIcons;
